import {Card, CardContent, Typography} from "@mui/material";
import React, {useEffect} from "react";
import CCOHeadline from "../fundamentals/CCOHeadline";
import CCOContainer from "../fundamentals/CCOContainer";
import {SosThemeProvider, useThemeContext} from "../../theming/ThemeContext";
import NextLink from "next/link";
import {PORTAL_HP_URL} from "../../common/constants/routes";
import {useTheme} from "@mui/material/styles";

interface Props {
    statusCode: number,
    rootUrl?: string
}

function ErrorPage(props: Props) {
    const theme = useTheme();
    const themeContext = useThemeContext();
    const h1 = "Fehler - " + props.statusCode;
    const url = props.rootUrl ? props.rootUrl : PORTAL_HP_URL;

    useEffect(() => {
        const rootCtx = url.replaceAll('/', '');
        themeContext.setTheme(rootCtx);
    }, [url, themeContext]);

    const colorContainer = theme.palette.primary.light;
    const linkColor = theme.palette.primary.main;
    return <SosThemeProvider>
        <CCOContainer dataCypress={'errorContainer'} background={colorContainer}>
            <Card variant="outlined">
                <CardContent>
                    <CCOHeadline headline={h1} type={"h1"} justify={"left"}/>
                    { props.statusCode === 404 ?
                        <Typography>HTTP {props.statusCode} - Die Seite konnte nicht gefunden werden</Typography> :
                        <Typography>HTTP {props.statusCode} - Da hat etwas nicht funktioniert</Typography>}
                    <NextLink id={"link-error-back-to-hp"} shallow={false} href={url} prefetch={false}>
                        <Typography color={linkColor}>Zurück zur Startseite</Typography>
                    </NextLink>
                </CardContent>
            </Card>
        </CCOContainer>
    </SosThemeProvider>
}


export default ErrorPage